
import { Component, Vue, Prop } from "vue-property-decorator";
import TestModal from "../modal/testModal.vue";
@Component({
  components: { TestModal },
})
export default class Logout extends Vue {
  @Prop({ default: false }) public btnAcivte;
  @Prop({ default: {} }) public infoList;
  public initial = "";

  public onExtract() {
    // if (this.infoList.is_no_audit || this.infoList.is_on_speed_up) {
    //   const refTestModal = this.$refs.refTestModal as any;
    //   refTestModal.show(
    //     this.infoList.is_on_speed_up
    //       ? "请等待本次极速提现完成后，再发起新的提现"
    //       : "请等待本次提现完成后，再发起新的提现"
    //   );
    //   return;
    // }
    this.$emit("onExtract");
  }
  public onTopspeed() {
    // if (this.infoList.is_no_audit || this.infoList.is_on_speed_up) {
    //   const refTestModal = this.$refs.refTestModal as any;
    //   refTestModal.show(
    //     this.infoList.is_on_speed_up
    //       ? "请等待本次极速提现完成后，再发起新的提现"
    //       : "请等待本次提现完成后，再发起新的提现"
    //   );
    //   return;
    // }
    this.$emit("onTopspeed");
  }
  public onSVIPInterestDetails(type?: number) {
    if (type == 1 && this.infoList.is_on_speed_up) {
      const refTestModal = this.$refs.refTestModal as any;
      refTestModal.show("请等待本次极速提现完成后，再发起新的提现");
    } else {
      (window as any).sendSVIPInterest();
    }
  }
  public getExplain(text) {
    if (!text) return "";
    const arr = text.split("\n");
    let explainText = "";
    arr.map((item, index) => {
      explainText += index
        ? `<p class="payinfo_text">${item}</p>`
        : `<p class="payinfo_title">${item}</p>`;
    });
    return explainText;
  }
}
